import { ReactNode } from "react";

interface SectionProps {
  id?: string;
  title?: string;
  eyebrow?: string;
  description?: string;
  children?: ReactNode;
}

const Section = ({
  id,
  title,
  eyebrow,
  description,
  children,
}: SectionProps) => {
  return (
    <section id={id} className="py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {(eyebrow || title || description) && (
          <header className="max-w-3xl mb-12">
            {eyebrow && <p className="kicker mb-3">{eyebrow}</p>}
            {title && (
              <h2 className="text-3xl sm:text-4xl font-semibold text-ink mb-4 leading-[1.08]">
                {title}
              </h2>
            )}
            {description && (
              <p className="text-sm sm:text-base text-muted">{description}</p>
            )}
          </header>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
